import { useContext, Fragment, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Badge from "@mui/material/Badge";
import ShoppingCart from "../assets/svg/shopping_cart.svg";
import * as language from "../constants/languages";
import CompanyLogo from "../assets/header_logo.png";
import { AuthContext } from "../pages/RootPage";
import { useNavigate } from "react-router-dom";

export default function SideBar({ drawerState }) {
  const { toggleDrawer } = useContext(AuthContext);
  const navigate = useNavigate();
  const [logo, setlogo] = useState();
  const [badgeCount, setbadgeCount] = useState(0);

  useEffect(() => {
    getCompanyInfo();
    getCartCount();
    window.addEventListener("productQtyChange", getCartCount);
    return () => {
      window.removeEventListener("productQtyChange", getCartCount);
    };
  }, []);

  const getCartCount = () => {
    const cart = localStorage.getItem("cartItems");
    if (!cart) {
      setbadgeCount(0);
    } else {
      const cartItems = JSON.parse(cart);
      setbadgeCount(cartItems?.customerCartItems?.length || 0);
    }
  };

  async function getCompanyInfo() {
    const value = localStorage.getItem("companyInfo");

    if (value) {
      let companyInfo = JSON.parse(value);
      const Logo = companyInfo.logo !== "" ? companyInfo.logo : CompanyLogo;
      setlogo(Logo);
    }
  }
  return (
    <div>
      <Fragment>
        <Drawer
          anchor={"left"}
          open={drawerState}
          className="remove-scrollbar"
          onClose={() => toggleDrawer()}
        >
          <Box
            sx={{ width: "auto", height: "100%" }}
            role="presentation"
            onClick={() => toggleDrawer()}
            onKeyDown={() => toggleDrawer()}
            className="sidebarBackground"
          >
            <Box>
              <div
                className="sidebarLogoContainer"
                onClick={(e) => {
                  e.stopPropagation();
                  toggleDrawer();
                  navigate("/");
                }}
                style={{ cursor: "pointer" }}
              >
                <img src={"/images/logo.png"} className="sidebarLogoStyle" alt="Store Logo" style={{ cursor: "pointer" }} />
              </div>
            </Box>
            <List className="remove-scrollbar">
              <ListItem disablePadding onClick={() => navigate("/")}>
                <ListItemButton>
                  <ListItemText sx={{ color: "white" }} primary="Home" />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding onClick={() => navigate("/Cart")}>
                <ListItemButton sx={{ display: "flex", justifyContent: "space-between" }}>
                  <ListItemText sx={{ color: "#f79723", fontWeight: "bold" }} primary="My Cart" />
                  <Badge badgeContent={badgeCount} color="warning">
                    <img src={ShoppingCart} style={{ width: 22, height: 22, filter: "brightness(0) invert(1)" }} alt="Cart" />
                  </Badge>
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding onClick={() => navigate("/Categories")}>
                <ListItemButton>
                  <ListItemText sx={{ color: "white" }} primary="Categories" />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding onClick={() => navigate("/Offers")}>
                <ListItemButton>
                  <ListItemText
                    sx={{ color: "white" }}
                    primary={language.offers}
                  />
                </ListItemButton>
              </ListItem>
              <ListItem disablePadding onClick={() => navigate("/Franchise")}>
                <ListItemButton>
                  <ListItemText sx={{ color: "white" }} primary={"Franchise"} />
                </ListItemButton>
              </ListItem>

              <ListItem disablePadding onClick={() => navigate("/About")}>
                <ListItemButton>
                  <ListItemText
                    sx={{ color: "white" }}
                    primary={language.aboutProfileLable}
                  />
                </ListItemButton>
              </ListItem>
            </List>
          </Box>
        </Drawer>
      </Fragment>
    </div>
  );
}
